/**
 * @file This is the main file of the app, all it does is mount a LicenseApp.
 * If you're looking for app logic, you probably want LicenseApp.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { FluentProvider, Theme, tokens, webLightTheme } from '@fluentui/react-components';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

import { LicenseApp } from './LicenseApp';
import { msalConfig } from './apis';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLDivElement);

const pca = new PublicClientApplication(msalConfig);

const anarkTheme: Theme = {
  ...webLightTheme,
  colorNeutralBackground4: "#232A2E",
  colorNeutralBackground4Hover: "#1E1E1E",
  colorNeutralForeground2: 'white',
}

const AppProvider = () => (
  <MsalProvider instance={pca}>
    <FluentProvider theme={anarkTheme}>
        <LicenseApp />
    </FluentProvider>  
  </MsalProvider>
);

root.render(<AppProvider/>);
